import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { UPDATE_CHAT_STATUS } from "src/api-setup/api-endpoints";

export const updateChatStatus = async (cookiesData, dispatch, conversationId) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: String(cookiesData?.out_user_id) || 0,
      in_tenant_id: cookiesData?.out_tenant_id || "",
      in_conversation_mstr_key: String(conversationId),
      in_conversation_status: "RESOLVED",
    };
    const response = await POSTAPI(false, UPDATE_CHAT_STATUS, null, apiHeaders, requestBody, dispatch);
    if (response && response.data) {
      return response;
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
